import { Component, Inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheet } from '@angular/material/bottom-sheet';

@Component({
  selector: 'confirm',
  styleUrls: [],
  template: `
    <div elementSpacing="mar-spacing-default-xl"></div>
    
    <mat-icon *ngIf="data?.icon" >{{ data.icon }}</mat-icon>
    <div *ngIf="data?.icon" elementSpacing="mar-spacing-default-md"></div>
    
    <h1 textStyle="mar-label-lg" color="mar-text-primary">{{ data.title }}</h1>
    <div elementSpacing="mar-spacing-default-md"></div>
    
    <div mat-dialog-content >
      <p textStyle="mar-body-sm" color="mar-text-tertiary" [innerHTML]="data.message"></p>
      <div elementSpacing="mar-spacing-default-2xl"></div>
    </div>
    <div mat-dialog-actions class="pb-4" *ngIf="data?.buttonCancel?.show || data?.buttonConfirm?.show">
      <div fxFill fxLayout="row" fxLayout.xs="column" fxLayoutGap="8px">
        <div fxFlex="100" *ngIf="data?.buttonConfirm?.show">
          <button
            [class.maria]="data.theme === 'maria'"
            fxFlex="100"
            mat-flat-button
            type="submit"
            color="primary"
            (click)="matBottomSheet.dismiss(true)"
            class="w-full ml-none"
          >
            {{ data?.buttonConfirm?.label }}
          </button>
        </div>
        <div fxFlex="100" *ngIf="data?.buttonCancel?.show">
          <button
            [class.maria]="data.theme === 'maria'"
            fxFlex="100"
            mat-dialog-close
            color="accent"
            mat-raised-button
            type="button"
            (click)="matBottomSheet.dismiss(false)"
          >
            {{ data?.buttonCancel?.label }}
          </button>
        </div>

      </div>
    </div>
  `,
  standalone: false
})
export class ConfirmBottomComponent {
  constructor(
    public matBottomSheet: MatBottomSheet,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
  ) {
  }
}
